import React from 'react';

export default function ImpressumPage() {
  return (
    <div className="max-w-3xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-4 text-primary-600">Impressum</h1>
      <p className="mb-4">Angaben gemäß § 5 TMG</p>
      <p className="mb-4">Max Mustermann<br/>Musterstraße 1<br/>12345 Musterstadt<br/>E-Mail: info@naturalme.de</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">Verantwortlich für den Inhalt</h2>
      <p className="mb-4">Max Mustermann</p>
      <h2 className="text-xl font-semibold mt-8 mb-2">Haftungsausschluss</h2>
      <p className="mb-4">Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.</p>
    </div>
  );
}
